import { h, Component, Fragment } from "preact";
import { route } from "preact-router";
import { msg } from "@lingui/core/macro";
import { Trans } from "@lingui/react/macro";

import PFeed from "../../../services/prematch-feed";
import Page from "../../../services/page-data-feed";
import Ticket from "../utils/ticket-logic.jsx";

import * as L from "../desktop-templates/live-general.jsx";
import * as S from "../mobile-templates/sports.jsx";
import * as O from "../desktop-templates/prematch-single-event.jsx";
import * as W from "../desktop-templates/prematch-home.jsx";
import {StatsIconRegular} from "../../betplay/utils/icons";
import {TodayWidget} from './today-widget.jsx';
import AwrabetPrematchHomeWidgets, {
	MostPlayedList as AwrabetMostPlayedList,
	MostBetList as AwrabetMostBetList,
	NextEventsList as AwrabetNextEventsList
} from '../../awrabet/desktop-components/prematch-home.jsx';

export default class PrematchHomeWidgets extends AwrabetPrematchHomeWidgets {

	render() {
		if (this.state.sports == null)
			return null;
		const isSoccer = this.state.currentSport.id == '/sport/1';
		return (
			<div>
				<SportsList sports={this.state.sports} currentSport={this.state.currentSport.id} onChange={sport => this.setSport(sport)} />
				<W.SwitcherButtons>
					<W.Button selected={this.state.tab == "today-events"} onClick={() => this.setTab("today-events")}>
						<Trans>Today Events</Trans>
					</W.Button>
					<W.Button selected={this.state.tab == "next-events"} onClick={() => this.setTab("next-events")}>
						<Trans>Upcoming Events</Trans>
					</W.Button>
					{isSoccer && <W.Button selected={this.state.tab == "most-played"} onClick={() => this.setTab("most-played")}>
						<Trans>Most Played</Trans>
					</W.Button>}
					{isSoccer && <W.Button selected={this.state.tab == "most-bet"} onClick={() => this.setTab("most-bet")}>
						<Trans>Top Occurrences</Trans>
					</W.Button>}
				</W.SwitcherButtons>
				<W.TabContainer>
					{this.state.tab == "today-events" ? (
						<TodayWidget sport={this.state.currentSport} key={this.state.currentSport.id} />
					) : this.state.tab == "next-events" ? (
						<NextEventsList sport={this.state.currentSport} key={this.state.currentSport.id} />
					) : this.state.tab == "most-played" ? (
						<MostPlayedList sport={this.state.currentSport} key={this.state.currentSport.id} />
					) : this.state.tab == "most-bet" ? (
						<MostBetList sport={this.state.currentSport} key={this.state.currentSport.id} />
					) : null}
				</W.TabContainer>
			</div>
		);
	}
};

const SportsList = ({ sports, currentSport, onChange }) => {
	return (
		<L.SportScrollBar>
			<L.SportsContainer>
				{sports && sports.map((sport) => (
					<L.SportButton active={sport.id == currentSport} onClick={(e) => onChange(sport)}>
						<S.SportIconBox>
							<S.SportIcon sport={sport} />
						</S.SportIconBox>
						<S.SportName>{sport.name}</S.SportName>
					</L.SportButton>
				))}
			</L.SportsContainer>
		</L.SportScrollBar>
	);
};

export class MostPlayedList extends AwrabetMostPlayedList {
	render({ sport }) {
		const displayRuleMarkets = this.state.displayRule;
		const events = this.state.events;
		if (events == null) return null;
		return (
			<W.MatchesTable>
				<W.MarketsStrip>
					{displayRuleMarkets.map((market) => (
						<W.MarketName size={market.sub.length}>{this.state.marketsNames[market.id] && this.state.marketsNames[market.id].name}</W.MarketName>
					))}
				</W.MarketsStrip>
				<W.Matches>
					{events && events.filter(ev => PFeed.NStorage.get(ev.parent) != null).map((event) => (
						<W.MatchRow key={event.id}>
							<W.MatchInfo>
								<W.MatchTopInfo>
									<W.MatchTournament event={event} {...PFeed.getWithParents(event.parent)} />
									<W.MatchDate date={event.date*1000} />
								</W.MatchTopInfo>
								<W.MainMatchInfo>
									<a href="javascript:void(0);" class="shrink-0 w-7 flex items-center justify-center" onClick={e => Page.openEventStats(event)}><StatsIconRegular class="h-4" /></a>
									<W.MatchName event={event} />
									<W.AvailableMarkets onClick={() => this.openEvent(event)} />
								</W.MainMatchInfo>
							</W.MatchInfo>
							<W.Markets>
								{displayRuleMarkets.map((market) => (
									<W.Market size={market.sub.length}>
										{market.sub.map((outcome) => {
											const odd = this.getOptionalOdd(event, outcome);
											return (
												<O.OutcomeButton
													key={odd.id}
													selected={Ticket.hasPrematchOdds(odd.id)}
													onClick={() => Ticket.togglePrematchOdds(odd.id)}
												>
													<O.OutcomeName>{odd.name}</O.OutcomeName>
													<O.OutcomeValue selected={Ticket.hasPrematchOdds(odd.id)} value={odd.value} />
												</O.OutcomeButton>
											);
										})}
									</W.Market>
								))}
							</W.Markets>
						</W.MatchRow>
					))}
				</W.Matches>
			</W.MatchesTable>
		);
	}
}

export class MostBetList extends AwrabetMostBetList {
	render({ sport }) {
		const displayRuleMarkets = this.state.displayRule;
		const events = this.state.events;
		if (events == null) return null;
		return (
			<W.MatchesTable>
				<W.MarketsStrip>
					{displayRuleMarkets.map((market) => (
						<W.MarketName size={market.sub.length}>{this.state.marketsNames[market.id] && this.state.marketsNames[market.id].name}</W.MarketName>
					))}
				</W.MarketsStrip>
				<W.Matches>
					{events && events.filter(ev => PFeed.NStorage.get(ev.parent) != null).map((event) => (
						<W.MatchRow key={event.id}>
							<W.MatchInfo>
								<W.MatchTopInfo>
									<W.MatchTournament event={event} {...PFeed.getWithParents(event.parent)} />
									<W.MatchDate date={event.date*1000} />
								</W.MatchTopInfo>
								<W.MainMatchInfo>
									<a href="javascript:void(0);" class="shrink-0 w-7 flex items-center justify-center" onClick={e => Page.openEventStats(event)}><StatsIconRegular class="h-4" /></a>
									<W.MatchName event={event} />
									<W.AvailableMarkets onClick={() => this.openEvent(event)} />
								</W.MainMatchInfo>
							</W.MatchInfo>
							<W.Markets>
								{displayRuleMarkets.map((market) => (
									<W.Market size={market.sub.length}>
										{market.sub.map((outcome) => {
											const odd = this.getOptionalOdd(event, outcome);
											return (
												<O.OutcomeButton
													key={odd.id}
													selected={Ticket.hasPrematchOdds(odd.id)}
													onClick={() => Ticket.togglePrematchOdds(odd.id)}
												>
													<O.OutcomeName>{odd.name}</O.OutcomeName>
													<O.OutcomeValue selected={Ticket.hasPrematchOdds(odd.id)} value={odd.value} />
												</O.OutcomeButton>
											);
										})}
									</W.Market>
								))}
							</W.Markets>
						</W.MatchRow>
					))}
				</W.Matches>
			</W.MatchesTable>
		);
	}
}

class NextEventsList extends MostBetList {
	componentWillMount() {
		Page.openNextEventsMerged(this.props.sport.id, 8, {}, (tag, tournamentCard) => {
			this.processResponse(tournamentCard);
		});
	}
}

